import BaseModelAPI from '../BaseModelAPI';

export default class ReportMTTRList extends BaseModelAPI {

	static entity = 'newreport2016list'
	static entityName = 'reportmttr';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
